module.exports = __webpack_public_path__ + "img/svip_big.99a9707b.svg";